(function () {
  if (window.__collapsibleFiltersDefined) return;
  window.__collapsibleFiltersDefined = true;

  function setExpanded(list, expanded) {
    list.classList.toggle('is-expanded', expanded);
    var toggle = list.querySelector('[data-toggle-collapsible]');
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    var more = toggle.querySelector('.checkbox-list__toggle-more');
    var less = toggle.querySelector('.checkbox-list__toggle-less');
    if (more) more.hidden = expanded;
    if (less) less.hidden = !expanded;
  }

  function autoExpandLists(root) {
    var lists = (root || document).querySelectorAll('[data-collapsible-list]');
    lists.forEach(function (list) {
      var visible = parseInt(list.getAttribute('data-visible-count'), 10) || 4;
      var items = list.querySelectorAll('.checkbox-container');
      for (var i = visible; i < items.length; i++) {
        var input = items[i].querySelector('input[type="checkbox"]');
        if (input && input.checked) { setExpanded(list, true); break; }
      }
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-toggle-collapsible]');
    if (!toggle) return;
    var list = toggle.closest('[data-collapsible-list]');
    if (!list) return;
    e.preventDefault();
    setExpanded(list, !list.classList.contains('is-expanded'));
  });

  autoExpandLists();
  document.addEventListener('facet:update', function () {
    setTimeout(autoExpandLists, 0);
  });
  document.addEventListener('facet:after-update', function () { setTimeout(autoExpandLists, 0); });

  function openBrandAccordion(root) {
    var brand = (root || document).querySelector('#accordion-filter-p-vendor');
    if (!brand || brand.open) return;
    var summary = brand.querySelector('summary');
    if (summary) summary.click();
  }

  var brandAccordionOpenedOnce = false;
  function ensureBrandAccordionOpenInitially() {
    if (brandAccordionOpenedOnce) return;
    brandAccordionOpenedOnce = true;
    openBrandAccordion();
  }
  ensureBrandAccordionOpenInitially();
  document.addEventListener('facet:update', function () { setTimeout(ensureBrandAccordionOpenInitially, 0); });
  document.addEventListener('facet:after-update', function () { setTimeout(ensureBrandAccordionOpenInitially, 0); });
})();
